<template>
  <div class="text-center">
    <v-dialog v-model="$store.state.statusDialog.dialog" persistent width="520">
      <v-card v-if="$store.state.statusDialog.type" class="text-center" outlined :elevation="0">
        <v-card-subtitle class="py-4">
          <v-icon
            :color="$store.state.statusDialog.type"
            size="90"
          >
            {{ getIcon($store.state.statusDialog.type) }}
          </v-icon>
          <div :class="`text-h5 text-capitalize ${$store.state.statusDialog.type}--text`" v-html="$store.state.statusDialog.type"></div>
        </v-card-subtitle>
        <v-card-text class="my-0">
          <pre class="text-h6" style="white-space: pre-wrap;">{{ $store.state.statusDialog.message }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-btn
            min-width="100"
            class="mx-auto"
            :color="$store.state.statusDialog.type"
            @click="closeDialog"
            large
            rounded
            outlined
            :elevation="0"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    getIcon(type){
      if(type === "success"){
        return "mdi-check-circle-outline";
      }
      else if(type === "error"){
        return "mdi-cancel";
      }
      else if(type === "info"){
        return "mdi-information-outline";
      }
      else if (type === "warning"){
        return "mdi-alert";
      }
      else {
        return "mdi-help-circle-outline";
      }
    },
    closeDialog(){
      this.$store.commit('statusDialog/resetDialog');
    }
  }
};
</script>
